class ContentManager {
  constructor() {
    this.contentBlocks = document.querySelectorAll('[data-content-block]');
    this.listItems = document.querySelectorAll('[data-list-item]');
    this.tabElements = document.querySelectorAll('[data-tab]');
    this.initEventListeners();
  }

  initEventListeners() {
    this.listItems.forEach((item) => {
      item.addEventListener('click', () => {
        this.showContent(item.getAttribute('data-target'));
        this.setActiveItem(item);
      });
    });

    this.tabElements.forEach((tab) => {
      const observer = new MutationObserver(() => {
        if (tab.className !== 'visually-hidden') {
          this.openClosest(tab);
        }
      });
      observer.observe(tab, {
        attributes: true,
      });
    });
  }

  openClosest(tab) {
    const item = tab.querySelector('.studyPrograms__list-item');
    const target = item?.getAttribute('data-target');
    if (target) {
      this.showContent(item.getAttribute('data-target'));
      this.setActiveItem(item);
    }
  }

  showContent(targetAttr) {
    this.hideAllContent();
    document.querySelector(`[data-content-block="${targetAttr}"]`).style.display = 'block';
  }

  hideAllContent() {
    this.contentBlocks.forEach((block) => {
      block.style.display = 'none';
    });
  }

  setActiveItem(item) {
    this.listItems.forEach((el) => {
      el.classList.remove('tab-active');
    });
    item.classList.add('tab-active');
  }
}

function initContentManager() {
  new ContentManager();
}

export { initContentManager };
